import React from 'react';
import styled from 'styled-components';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import useAccordionFaqs from '@utils/useAccordionFaqs';
import useProcessedFaqs from '@utils/useProcessedFaqs';
import Colors from '../Colors';
import Accordion from './Accordion';

const ShoppingFaqs: React.FC = () => {
  const { productHeaderData } = useShoppingContext();
  const { product_header_faqs } = productHeaderData;
  const processedFaqs = useProcessedFaqs(product_header_faqs);
  const accordionData = useAccordionFaqs(processedFaqs);

  if (!accordionData?.length) {
    return null;
  }

  return (
    <Container>
      <Accordion items={accordionData} iconsColor={Colors.navyBlue} iconsSize="12px" titleUppercase bottomDivider />
    </Container>
  );
};

export default ShoppingFaqs;

const Container = styled.div`
  margin-top: 8px;
  width: 100%;
`;
